import { render, staticRenderFns } from "./systemLogs.pug?vue&type=template&id=6f5408fb&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./systemLogs.scss?vue&type=style&index=0&id=6f5408fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5408fb",
  null
  
)

export default component.exports